import { handleActions } from 'redux-actions'
import { fromJS } from 'immutable'

import { NAME } from './constants'

export const initialState = fromJS({
  fetched: false,
  initialValues: {},
  success: false,
})

export default handleActions(
  {
    [NAME]: {
      SET: (state, { payload }) => state.merge(payload),
      SET_INITIAL_VALUES: (state, { payload }) =>
        state.mergeIn(['initialValues'], payload).set('fetched', true),
      UPDATE_INITIAL_VALUES: (state, { payload }) =>
        state.mergeIn(['initialValues'], payload),
    },
  },
  initialState,
)



// WEBPACK FOOTER //
// ../source/views/Signup/reducer.js